import { ReactNode } from 'react';

import {
  ConditionalWrapper,
  LabelChip,
  Typography,
  Box,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { RffControlsProvider } from '@cast/shared-rff-ui';

type Props = {
  title: string;
  inputA: ReactNode;
  inputB?: ReactNode;
  comingSoon?: boolean;
};

export const InputsSection = ({ title, inputA, inputB, comingSoon }: Props) => {
  return (
    <Stack gap={8}>
      <ConditionalWrapper
        condition={!!comingSoon}
        wrapper={(title) => (
          <Stack direction="row" alignItems="center" gap={8}>
            {title}
            <LabelChip
              sx={{
                backgroundColor: colorOrToken(
                  'indigo.200',
                  tokens.theme.bg.status.discoverySubtle
                ),
                color: colorOrToken(
                  '#fff',
                  tokens.theme.fg.status.onDiscoverySubtle
                ),
              }}
              size="2xs"
            >
              Coming soon
            </LabelChip>
          </Stack>
        )}
      >
        <Typography variant="A2">{title}</Typography>
      </ConditionalWrapper>
      <RffControlsProvider disabled={comingSoon}>
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={24}>
          {inputA}
          {inputB}
        </Box>
      </RffControlsProvider>
    </Stack>
  );
};
